import { render, staticRenderFns } from "./AddBalance.vue?vue&type=template&id=cfaeef54&scoped=true"
import script from "./AddBalance.vue?vue&type=script&lang=js"
export * from "./AddBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaeef54",
  null
  
)

export default component.exports